import { render, staticRenderFns } from "./NavigationBreadcrumb.vue?vue&type=template&id=77999512&scoped=true"
import script from "./NavigationBreadcrumb.vue?vue&type=script&lang=js"
export * from "./NavigationBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./NavigationBreadcrumb.vue?vue&type=style&index=0&id=77999512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77999512",
  null
  
)

export default component.exports